import { render, staticRenderFns } from "./userAgreen.vue?vue&type=template&id=7f164742&scoped=true"
import script from "./userAgreen.vue?vue&type=script&lang=js"
export * from "./userAgreen.vue?vue&type=script&lang=js"
import style0 from "./userAgreen.vue?vue&type=style&index=0&id=7f164742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f164742",
  null
  
)

export default component.exports